module.exports = __webpack_public_path__ + "img/行为分析.086df374.svg";